import React from 'react';

import { roleCategories } from 'utils/constants';
import { useUserRoleMatchCategory } from 'utils/hooks';

import DistributorReporting from './DistributorReporting';
import ServicerReporting from './ServicerReporting';

const Reporting = () => {
    const userIsServicer = useUserRoleMatchCategory(roleCategories.SERVICERS);

    return userIsServicer ? <ServicerReporting /> : <DistributorReporting />;
};

export default Reporting;
